import ViewBox from "./ViewBox.js";
class SVG {
    constructor(width, height, x0, y0, dx, dy) {
        this._width = width;
        this._height = height;
        this._viewBox = new ViewBox(x0, y0, dx, dy);
        this._paths = [];
    }
    addPath(path) {
        this._paths.push(path);
    }
    toString() {
        var pathString = this._paths.join(" ");
        return `<svg version="1.1" width="${this._width}" height="${this._height}" viewBox="${this._viewBox}" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg">${pathString}</svg>`;
    }
}
export default SVG;
